<template>
    <div class="subform-item">
        <draggable :list="fieldList" :options="subformContentOpts" class="subform-field-list" @change="handleFormChange">
            <transition-group name="list-complete">
                <div class="subform-field-item ellipsis"
                    v-for="(element, index) in fieldList"
                    :key="element.id"
                    @click.stop="handleSelectItem(element)">
                    {{ element.name }}
                    <i class="el-icon-delete form-del" @click.stop="handleDeleteItem(index)" title="删除"></i>
                </div>
            </transition-group>
        </draggable>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable';
    import * as formBaseField from './formBaseField';
    import { getUUID } from '@/utils/grocer';
    export default {
        data () {
            return {
                list: [formBaseField.getTextField()],
                subformContentOpts: {
                    // handle: '.form-item-label',
                    group: {
                        name: 'subformContent',
                        put: [ 'formToolbar' ]
                    },
                    sort: true
                }
            };
        },
        components: {
            Draggable
        },
        props: {
            fieldList: {
                type: Array
            }
        },
        methods: {
            handleDeleteItem (index) {
                this.fieldList.splice(index, 1);
            },
            handleSelectItem (field) {
                this.$emit('itemSelect', {
                    field
                });
            },
            _itemChangeAdd (obj) {
                // 克隆新增的字段，保证每个对象的独立性
                let objClone = JSON.parse(JSON.stringify(obj.element));
                const uuid = getUUID(16, 16);
                objClone.id = uuid;
                // objClone.uuid = uuid;
                objClone.formField = `${objClone.type}_${uuid}`;
                this.fieldList.splice(obj.newIndex, 1, objClone);
            },
            handleFormChange (changeObj) {
                if (changeObj && changeObj.added) {
                    // console.log(changeObj.added.element.type);
                    if (changeObj.added.element.type === 'divider') {
                        this.$message.warning('分割线不能用于子表单,请移除');
                        return;
                    }
                    this._itemChangeAdd(changeObj.added);
                }
                // this.$emit('itemChange', {
                //     fieldList: this.list
                // });
            }
        }
    };
</script>

<style lang="less">
    .subform-item {
        flex: 1;
        display: flex;
        padding: 0;
        height: auto;
        flex-wrap: wrap;
        .subform-field-list {
            flex: 1;
        }
        .subform-field-list > span {
            height: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
        }
        .subform-field-item {
            position: relative;
            max-width: 100px;
            text-align: center;
            height: 30px;
            line-height: 30px;
            padding: 0 20px;
            margin: 6px 10px;
            background-color: #f2f6ff;
            border: 1px solid #ececec;
            cursor: move;
            // margin-top: 1vh;
        }
        .subform-field-item:hover {
            border: 1px solid #f2f6ff;
            box-shadow: 0 0 4px rgba(0,0,0,.3);
        }
        .subform-field-item:hover .form-del {
            display: inline-block;
        }
        .form-del {
            position: absolute;
            right: 6px;
            cursor: pointer;
            top: 10px;
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/CustomForm/SubformField.vue